import { passwordMeetsAllRequirements } from '@/utils/passwordRequirements'

export function changePasswordClientError(input: {
  currentPassword: string
  newPassword: string
  confirmPassword: string
}): string | null {
  if (!input.currentPassword.trim()) return 'Informe a senha atual'
  if (!passwordMeetsAllRequirements(input.newPassword)) {
    return 'A nova senha precisa ter letra maiúscula, minúscula, número e caractere especial'
  }
  if (input.newPassword === input.currentPassword) return 'A nova senha deve ser diferente da atual'
  if (input.newPassword !== input.confirmPassword) return 'As senhas não coincidem'
  return null
}
